import { ProcedimentoVO } from "./procedimentoVO";

export class IstanzaAttivitaVO {
  id: string;

  nome: string;

  codice: string;

  procedimentiAssociati: ProcedimentoVO[];
}
